import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';

export function isValidGetSharingInfoResponse(response: GetSharingInfoResponse) {
    return response && response.ResultCode === AttachmentResultCode.Success;
}
